import { sortByLoanAmountRoutine, sortByGrantAmountRoutine, sortByInterestRateRoutine, sortByDecisionTimeRoutine, sortByProductTypeRoutine, SORT_BAR_CLEANUP } from './routines'

export default {
  [sortByLoanAmountRoutine.TRIGGER](state, payload) {
    state.sortByLoanAmount = payload
  },
  [sortByGrantAmountRoutine.TRIGGER](state, payload) {
    state.sortByGrantAmount = payload
  },
  [sortByInterestRateRoutine.TRIGGER](state, payload) {
    state.sortByInterestRate = payload
  },
  [sortByDecisionTimeRoutine.TRIGGER](state, payload) {
    state.sortByDecisionTime = payload
  },
  [sortByProductTypeRoutine.TRIGGER](state, payload) {
    state.sortByProductType = payload
  },
  [SORT_BAR_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
